<template>
  <div class="kbank-payment-page">
    <div v-if="!ready" class="kbank-payment-page__loading">
      <v-progress-circular
        :size="72"
        :width="6"
        color="primary"
        indeterminate
      ></v-progress-circular>
      <p>กำลังเชื่อมต่อระบบชำระเงินที่ปลอดภัย…</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { showKBankEmbedUI, teardownKBankEmbedUI } from '@/utils/kbank'

export default {
  name: 'KBankPayment',

  data() {
    return {
      ready: false,
      pollId: null,
      closing: false,
    }
  },

  computed: {
    ...mapState({
      payload: state => state.kbank.kbankForm,
    }),

    embeds() {
      return this.payload && this.payload.embeds
        ? this.payload.embeds
        : null
    },

    returnRoute() {
      let returnRouteDefault = {
        name: 'Campaign',
      }

      if (this.$route?.params?.uuid) {
        returnRouteDefault = {
          name: 'OrderDetail',
          params: {
            orderId: this.$route?.params?.uuid,
          },
        }
      } else if (localStorage.getItem('productLatestVisit')) {
        returnRouteDefault = {
          name: 'ProductDetail',
          params: {
            slug: localStorage.getItem('productLatestVisit'),
          },
        }
      }

      return (
        (this.payload && this.payload.returnRoute) ||
        returnRouteDefault
      )
    },
  },

  created() {
    if (!this.embeds) {
      this.$toast.error(
        'ไม่สามารถเชื่อมต่อระบบชำระเงินได้ กรุณาลองใหม่อีกครั้ง',
        {
          position: 'top',
          duration: 8000,
          pauseOnHover: true,
        },
      )

      this.$router.replace(this.returnRoute).catch(() => {})
    }
  },

  mounted() {
    if (!this.embeds) {
      return
    }

    // Clear any scroll lock left behind by a Vuetify overlay / modal
    // (or a previous KBank session) so the SDK modal scrolls freely here.
    document.documentElement.classList.remove('overflow-y-hidden')
    document.body.classList.remove('freeze-overflow')
    document.body.classList.remove('scroll-y-hidden')

    showKBankEmbedUI(this.embeds)

    this.pollId = setInterval(() => {
      if (window.KPayment) {
        this.ready = true

        // The SDK has no programmatic close; onClose() registers the callback
        // it fires when the user dismisses KBank's own UI (or it expires).
        window.KPayment.onClose(() => this.onSdkClose())

        clearInterval(this.pollId)
        this.pollId = null
      }
    }, 300)
  },

  beforeDestroy() {
    if (this.pollId) {
      clearInterval(this.pollId)
      this.pollId = null
    }
    teardownKBankEmbedUI()
    this.$store.dispatch('kbank/setFormKBank', {})
  },

  beforeRouteLeave(to, from, next) {
    if (this.pollId) {
      clearInterval(this.pollId)
      this.pollId = null
    }
    teardownKBankEmbedUI()
    this.$store.dispatch('kbank/setFormKBank', {})

    next()
  },

  methods: {
    // Called when the user dismisses KBank's own payment UI (or it expires).
    // Route back to where the flow started; the route guards run
    // teardownKBankEmbedUI() to strip the SDK's leftover overlay + scroll lock.
    onSdkClose() {
      if (this.closing) {
        return
      }
      this.closing = true
      this.$router.replace(this.returnRoute).catch(() => {})
    },

    onCancel() {
      this.onSdkClose()
    },
  },
}
</script>

<style lang="stylus" scoped>
.kbank-payment-page
  position fixed
  inset 0
  z-index 100
  display flex
  flex-direction column
  background #fff
  overflow-y auto
  -webkit-overflow-scrolling touch

  &__bar
    flex 0 0 auto
    display flex
    align-items center
    height 52px
    padding 0 12px
    border-bottom 1px solid #ededed

  &__cancel
    display inline-flex
    align-items center
    gap 4px
    font-weight 600
    background transparent
    border 0
    cursor pointer
    color $color-dark-gray

  &__loading
    flex 1 1 auto
    display flex
    flex-direction column
    align-items center
    justify-content center
    gap 16px
    text-align center
    color $color-dark-gray
</style>
